/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type { FilterValues } from 'walden-fast/types/filters';
import { service } from '@ember/service';
import type { IntlService } from 'ember-intl';
import type FilterService from 'walden-fast/services/filter';
import {
  isDateRangeFilterRequired,
  type PowerBiPageRoute,
} from 'walden-fast/constants/power-bi';

interface FilterBarArgs {
  onApplyFilters: (filters: FilterValues) => void;
  pageRoute?: string;
}

export default class FilterBarComponent extends Component<FilterBarArgs> {
  @service('intl') declare intlService: IntlService;
  @service('filter') declare filterService: FilterService;

  constructor(owner: unknown, args: FilterBarArgs) {
    super(owner, args);
    this.loadFilters();
  }

  loadFilters() {
    const filters = this.filterService.currentFilters;
    if (filters) {
      this.args.onApplyFilters(filters);
    }
  }

  get months() {
    return this.filterService.months;
  }

  get years() {
    return this.filterService.years;
  }

  get fromMonth() {
    return this.filterService.fromMonth;
  }

  get fromYear() {
    return this.filterService.fromYear;
  }

  get toMonth() {
    return this.filterService.toMonth;
  }

  get toYear() {
    return this.filterService.toYear;
  }

  get clients() {
    return this.filterService.clients;
  }

  get selectedClientIds() {
    return this.filterService.selectedClientIds;
  }

  get dateError() {
    return this.filterService.dateError;
  }

  get isValid() {
    return this.filterService.isValid;
  }

  get hasAnyFilter() {
    return this.filterService.hasAnyFilter;
  }

  get clientCompanies() {
    return this.filterService.clientCompanies;
  }

  get shouldShowDateRangeFilter() {
    return this.args.pageRoute
      ? isDateRangeFilterRequired(this.args.pageRoute as PowerBiPageRoute)
      : true;
  }

  getMonthName = (monthValue: string) => {
    return this.filterService.getMonthName(monthValue);
  };

  @action
  updateFilter(field: string, selected: unknown) {
    this.filterService.updateFilter(field, selected);
  }

  @action
  updateClientIds(selectedClientIds: string[]): void {
    this.filterService.updateClientIds(selectedClientIds);
  }

  @action
  applyFilters() {
    const filters = this.filterService.applyFilters();
    if (filters) {
      this.args.onApplyFilters(filters);
    }
  }

  @action
  clearFilters() {
    const filters = this.filterService.clearFilters();
    this.args.onApplyFilters(filters);
  }

  @action
  validateDateRange() {
    const isValid = this.filterService.validateDateRange();
    if (!isValid) {
      alert(this.intlService.t('components.filterBar.error'));
    }
  }
}
